import { Toolbar, TableButton } from '@/shared/components/MaterialTableElements';
import PlusIcon from 'mdi-react/PlusIcon';

interface MatTableToolbarProps {
    onRequestAdd: () => void;
}

const MatTableToolbar = ({ onRequestAdd }: MatTableToolbarProps) => (
    <Toolbar className="material-table__toolbar">
        <div className="d-flex align-items-center justify-content-center" role="button" onClick={onRequestAdd}>
            <TableButton>
                <PlusIcon />
            </TableButton>
            <span>Add New Tip Pool</span>
        </div>
    </Toolbar>
);

export default MatTableToolbar;
